import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiEnvelope } from './promotions-api.types';
import {
  CatalogCategoryDto,
  CatalogPresentationDto,
  CatalogProductDto,
} from './product-catalog.types';

@Injectable({ providedIn: 'root' })
export class ProductCatalogApiService {
  private readonly http = inject(HttpClient);
  private readonly base = '/api/v1/product';

  private desenvolver<T>(fuente: Observable<ApiEnvelope<T>>): Observable<T> {
    return fuente.pipe(map((respuesta) => respuesta.data));
  }

  listarProductos(): Observable<CatalogProductDto[]> {
    return this.desenvolver(this.http.get<ApiEnvelope<CatalogProductDto[]>>(this.base));
  }

  listarPresentaciones(): Observable<CatalogPresentationDto[]> {
    return this.desenvolver(
      this.http.get<ApiEnvelope<CatalogPresentationDto[]>>(`${this.base}/product-presentation`),
    );
  }

  listarCategorias(): Observable<CatalogCategoryDto[]> {
    return this.desenvolver(
      this.http.get<ApiEnvelope<CatalogCategoryDto[]>>(`${this.base}/product-category`),
    );
  }
}
